import { render, staticRenderFns } from "./modal-user-navigation.vue?vue&type=template&id=bf4a31c2"
import script from "./modal-user-navigation.vue?vue&type=script&lang=ts"
export * from "./modal-user-navigation.vue?vue&type=script&lang=ts"
import style0 from "./modal-user-navigation.vue?vue&type=style&index=0&id=bf4a31c2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf4a31c2')) {
      api.createRecord('bf4a31c2', component.options)
    } else {
      api.reload('bf4a31c2', component.options)
    }
    module.hot.accept("./modal-user-navigation.vue?vue&type=template&id=bf4a31c2", function () {
      api.rerender('bf4a31c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layout/modal-user-navigation.vue"
export default component.exports